import React, { useEffect, useState } from 'react';
import Button from './Button';
import './InputRange.css';

function InputRange({ buttonClickHandler, inputRangeVisibility, buttonGirarState }) {
    const [rangeValue, setRangeValue] = useState(70);
    const [porcentaje, setPorcentaje] = useState(((rangeValue - 40) / 60) * 100);

    let inputBackground;
    useEffect(() => {
        inputBackground = document.getElementById('range-input');
        inputBackground.style.background = `linear-gradient(90deg, #4caf50 ${porcentaje}%, #ffffff ${porcentaje}%)`;
      });

    let potenciaGiro = rangeValue * 4;
    function rangeChange(e) {
        potenciaGiro = parseInt(e.target.value);
        setRangeValue(potenciaGiro);
        setPorcentaje(((potenciaGiro - 40) / 60) * 100);
        potenciaGiro *= 4;
        inputBackground.style.background = `linear-gradient(90deg, #4caf50 ${porcentaje}%, #ffffff ${porcentaje}%)`;
    }

    return (
        <div className={`range__container ${inputRangeVisibility}`} id="range__container">
            <div className="range-selector">
                <p className="range-text">Ajusta la fuerza de tiro:</p>
                <input
                  type="range"
                  id="range-input"
                  name="range-input"
                  className="range-input"
                  min="40"
                  max="100"
                  value={rangeValue}
                  // Cada vez que se mueve el rango, llama a la función para cambiar el state del componente
                  onChange={(e) => rangeChange(e)}
                />
            </div>
            <Button text="Girar" type="button-range" onClickHandler={() => buttonClickHandler(potenciaGiro)} state={buttonGirarState} />
        </div>
    );
}

export default InputRange;
